import { Stack, useLocalSearchParams, useNavigation } from 'expo-router';
import { pressableAttributes } from 'features/feeBasedInstantTransfer/helpers/analyticsFormatters';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { TRANSFER_TYPES } from 'shared/analytics/events/transferMoney';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import usePreventBackNavigation from 'shared/hooks/usePreventBackNavigation/usePreventBackNavigation';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';

function TransferProcessingScreen() {
  const { t } = useTranslation('feeBasedInstantTransfer');
  const navigation = useNavigation();
  const { transferId } = useLocalSearchParams<{ transferId?: string }>();
  const isLeavingRef = useRef(false);
  usePreventBackNavigation(true, (action) => {
    if (isLeavingRef.current) {
      navigation.dispatch(action);
    }
  });

  const handleDone = () => {
    isLeavingRef.current = true;
    navigateBack();
  };

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <SuccessScreen
        visual="HOURGLASS_A"
        screenAnalyticsEventKey="instantTransferProcessing"
        customAttributes={{
          transfer_type: TRANSFER_TYPES.PUSH_TO_CARD,
          ...(transferId ? { transfer_id: transferId } : null),
        }}
        titleText={t('processing.title')}
        content={
          <BodyBaseText numberOfLines={0} style={styles.message}>
            {t('processing.message')}
          </BodyBaseText>
        }
        primaryButton={{
          label: t('processing.done'),
          onPress: handleDone,
          analyticsId: 'transferMoneyProcessingDone',
          customAttributes: pressableAttributes('Done', 'primary'),
        }}
      />
    </>
  );
}

const styles = StyleSheet.create({
  message: { textAlign: 'center' },
});

export default TransferProcessingScreen;
